import { render } from "./App.vue?vue&type=template&id=e04160c8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=e04160c8&lang=scss"

import exportComponent from "C:\\Users\\romain.graye\\Downloads\\speaky-demo-vuejs\\speaky-demo-vuejs\\vue-starter-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__